"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtificialLake = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const SpaceType_1 = require("../../SpaceType");
const CardName_1 = require("../../CardName");
const constants_1 = require("../../constants");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
const TileType_1 = require("../../TileType");
class ArtificialLake extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ARTIFICIAL_LAKE,
            tags: [Tags_1.Tags.BUILDING],
            cost: 15,
            tr: { oceans: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.temperature(-6)),
            metadata: {
                description: 'Requires -6 C or warmer. Place 1 ocean tile ON AN AREA NOT RESERVED FOR OCEAN.',
                cardNumber: '116',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.oceans(1).asterix()),
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        const game = player.game;
        const board = game.board;
        const canPlaceTile = board.getAvailableSpacesOnLand(player).length > 0;
        if (game.noOceansAvailable())
            return true;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, game, actionDetails, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return canPlaceTile && this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return canPlaceTile;
    }
    play(player) {
        if (player.game.noOceansAvailable())
            return undefined;
        return new SelectSpace_1.SelectSpace('Select a land space to place an ocean', player.game.board.getAvailableSpacesOnLand(player), TileType_1.TileType.OCEAN, (foundSpace) => {
            player.game.addOceanTile(player, foundSpace.id, SpaceType_1.SpaceType.LAND);
            return undefined;
        });
    }
    getActionDetails(player, card) {
        const landSpaces = player.game.board.getAvailableSpacesOnLand(player);
        return new RedsPolicy_1.ActionDetails({ card: card, oceansToPlace: 1, nonOceanToPlace: TileType_1.TileType.OCEAN, nonOceanAvailableSpaces: landSpaces });
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.ArtificialLake = ArtificialLake;
//# sourceMappingURL=ArtificialLake.js.map